import theme from "@shared/utils/themeColors";
import { LoadingSpinner } from "../../../shared/components/LoadingSpinner";
import { useProfile } from "../../../shared/hooks/useProfile";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import NotificationsPanel from "../components/NotificationsPanel";
import SettingsSidebar from "../components/SettingsSidebar";

export default function NotificationsPage() {
  const { user, isLoading, error } = useProfile();

  return (
    <AuthenticatedLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        {/* Page header */}
        <div className="mb-8">
          {/* Title */}
          <h1
            className={`text-2xl md:text-3xl ${theme.text.primary} font-bold`}
          >
            Account Settings
          </h1>
        </div>

        {/* Content */}
        <div className={`${theme.bg.primary} shadow-sm rounded-xl mb-8`}>
          <div className="flex flex-col md:flex-row md:-mr-px">
            <SettingsSidebar />
            {isLoading ? (
              <div className="flex items-center justify-center w-full p-8">
                <LoadingSpinner />
              </div>
            ) : error ? (
              <div className={`p-8 text-center ${theme.text.error}`}>
                Error loading user data. Please try again.
              </div>
            ) : user ? (
              <NotificationsPanel user={user} />
            ) : null}
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
